import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DoubleRange from '@components/commonFilters/DoubleRange';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

const Gsm = ({ isClearAll, onResetClearValue }) => {
	const commonfilters = useSelector(getCommonFilters);
	const [min, setMin] = useState(0);
	const [max, setMax] = useState(300);
	const [isUpdated, setIsUpdated] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		if (isClearAll) {
			setMin(0);
			setMax(300);
			setIsUpdated(false);
			setTimeout(() => {
				setIsUpdated(true);
			}, 0);
		}
	}, [isClearAll]);

	const onChangeRange = (value) => {
		onResetClearValue(false);
		setMin(value.min);
		setMax(value.max);
		dispatch(setFilters({ ...commonfilters, minGsm: value.min, maxGsm: value.max }));
	};

	return (
		<div>
			<p>GSM</p>
			{isUpdated && <DoubleRange currentMin={min} currentMax={max} onChangeRange={onChangeRange} />}
		</div>
	);
};

export default Gsm;
